// extracted by mini-css-extract-plugin
module.exports = {"purchaseInventory":"PurchaseInventory_purchaseInventory__qAkF6","inventoryItem":"PurchaseInventory_inventoryItem__X_M2P","itemName":"PurchaseInventory_itemName__dGaIX"};